__turbopack_context__.v({
  "assetsLoading": "ReviewAndConfirmContent-module__4E0YIq__assetsLoading",
  "body": "ReviewAndConfirmContent-module__4E0YIq__body",
  "tableRecordsDescription": "ReviewAndConfirmContent-module__4E0YIq__tableRecordsDescription",
  "warningGroupHeading": "ReviewAndConfirmContent-module__4E0YIq__warningGroupHeading",
  "warningList": "ReviewAndConfirmContent-module__4E0YIq__warningList",
});
